<script lang="ts">
  import { WindowsCustomEventTypes } from '../../enums/windows-custom-event.enum';
  import { ConfigStore } from '../../store/config';
  import { _ } from 'svelte-i18n';
  import { state_fullScreen } from '../../../lib/store/state';
</script>

{#if $state_fullScreen}
  <button
    on:click={() => {
      window.dispatchEvent(
        new CustomEvent(WindowsCustomEventTypes.toggleFullScreen, {
          detail: false,
        })
      );
    }}
    style:color={$ConfigStore.customTheme.headerTextColor}
    aria-label={$_('header.toggle_resize')}
    title={$_('header.toggle_resize')}
    aria-expanded={false}
    aria-controls={$_('header.toggle_resize')}
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6_13446)">
        <path
          d="M5 16H8V19H10V14H5V16ZM8 8H5V10H10V5H8V8ZM14 19H16V16H19V14H14V19ZM16 8V5H14V10H19V8H16Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_13446">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  </button>
{:else}
  <button
    on:click={() => {
      window.dispatchEvent(
        new CustomEvent(WindowsCustomEventTypes.toggleFullScreen, {
          detail: true,
        })
      );
    }}
    style:color={$ConfigStore.customTheme.headerTextColor}
    aria-label={$_('header.toggle_resize')}
    title={$_('header.toggle_resize')}
    aria-expanded={true}
    aria-controls={$_('header.toggle_resize')}
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_6_13419)">
        <path
          d="M7 14H5V19H10V17H7V14ZM5 10H7V7H10V5H5V10ZM17 17H14V19H19V14H17V17ZM14 5V7H17V10H19V5H14Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_13419">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  </button>
{/if}

<style lang="scss">
  @use './../../../scss/components/themes/toggler-fullscreen-theme';
</style>
